<template>
  <div class="line-heading" :class="background">
    <div class="line"></div>
    <div
      class="text d-inline-block px-3 text-center text-uppercase font-weight-bold"
    >
      <slot></slot>
    </div>
  </div>
</template>

<script>
export default {
  props: {
    background: { type: String, default: "gray" },
  },
};
</script>

<style lang="scss" scoped>
@import "sass/_variables";
.line-heading {
  position: relative;
  text-align: center;
  .line {
    background-color: $gray-500;
    height: 1px;
    width: 100%;
    position: absolute;
    z-index: 0;
    top: 50%;
    transform: translateY(-50%);
  }
  .text {
    color: $gray-900;
    position: relative;
    z-index: 1;
  }
  &.gray .text {
    background-color: $body-bg;
  }
  &.white .text {
    background-color: #fff;
  }
}
</style>